/**
 * Canonical production origin. Used both for absolute URLs in meta tags and as
 * the @id base for schema.org nodes so individual page payloads can reference
 * the WebSite / app entity without re-emitting it.
 */
export const SITE_URL = "https://emulator.goatsquadstudios.com";

/** Default share card. Generated separately (referenced here only). */
export const OG_IMAGE = `${SITE_URL}/og/emulator-arcade.png`;

export type JsonLd = Record<string, unknown>;

/**
 * SoftwareApplication JSON-LD for the arcade itself. It's a free, browser- and
 * Discord-hosted game launcher, so applicationCategory is GameApplication and
 * the offer is a $0 free offer. Goat Squad Studios is carried as the `creator`
 * (publisher) Organization — no agency address/local-business signals, just the
 * entity + link back to the studio site.
 */
export function softwareAppJsonLd(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "@id": `${SITE_URL}#app`,
    name: "Emulator Arcade",
    applicationCategory: "GameApplication",
    operatingSystem: "Web / Discord",
    description:
      "Play NES, SNES, Game Boy, Genesis and a dozen other retro consoles right inside a Discord voice channel. Bring your own ROM, hit play, no install required.",
    url: SITE_URL,
    image: OG_IMAGE,
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    creator: {
      "@type": "Organization",
      name: "Goat Squad Studios",
      url: "https://goatsquadstudios.com",
    },
  };
}

/**
 * WebSite node for the home page. Establishes the site entity and links it to
 * Goat Squad Studios as publisher. No SearchAction — the site has no on-site
 * search endpoint to wire a sitelinks searchbox to.
 */
export function websiteJsonLd(): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}#website`,
    name: "Emulator Arcade",
    url: SITE_URL,
    publisher: {
      "@type": "Organization",
      name: "Goat Squad Studios",
      url: "https://goatsquadstudios.com",
    },
  };
}

/**
 * Stringify JSON-LD for embedding inside a <script type="application/ld+json">
 * tag via dangerouslySetInnerHTML. Accepts either a single payload or an
 * array (combined into a JSON array, the schema.org-supported "graph" form).
 */
export function jsonLdString(payload: JsonLd | JsonLd[]): string {
  return JSON.stringify(payload);
}
